import {
  CircularProgress,
  Dialog,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';
import {
  AccessTime,
  Check,
  DoneAll,
  ErrorOutline,
  GetApp,
  Image,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  SendRounded
} from '@material-ui/icons';
import {
  ASIM,
  DIRECAO_MSG_CHAT_ENVIADA,
  DIRECAO_MSG_CHAT_RECEBIDA,
  STATUS_MSG_CHAT_ENVIADA,
  STATUS_MSG_CHAT_ENVIANDO,
  STATUS_MSG_CHAT_ERRO,
  STATUS_MSG_CHAT_LIDA,
  STATUS_MSG_CHAT_RECEBIDA,
  TIPO_MSG_CHAT_DOCUMENTO,
  TIPO_MSG_CHAT_IMAGEM,
  TIPO_MSG_CHAT_TEXTO,
  WEBSOCKETURL
} from 'consts';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import { getConfigField } from 'lib/configUtils';
import { withStyles } from '@material-ui/core/styles';

const EVENTO_NOVA_MENSAGEM = 'whatsapp.nova_mensagem';
const EVENTO_MENSAGEM_ATUALIZADA = 'whatsapp.mensagem_atualizada';

const QTD_REGISTROS_PAGINA = 50;
const DISTANCIA_FINAL_SCROLL = 50;
const LARGURA_MAXIMA_MOBILE = 599;
const LARGURA_MENU_IMAGEM = 100;
const INTERVALO_PESQUISA = 400;
const NIVEL_MAXIMO_FORMATACAO = 10;
const TEMPO_MAXIMO_SCROLL = 3000;

const EXTENSOES_IMAGEM = {
  'image/jpeg': '.jpg',
  'image/jpg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
  'image/webp': '.webp',
  'image/bmp': '.bmp',
  'image/tiff': '.tif'
};

/* Marcadores de formatação do WhatsApp (monoespaçado, negrito, itálico e tachado) */
const MARCADORES_WHATSAPP = [
  { tipo: 'monoespaco', regex: /`([^`]+)`/ },
  { tipo: 'negrito', regex: /\*([^*\n]+)\*/ },
  { tipo: 'italico', regex: /_([^_\n]+)_/ },
  { tipo: 'tachado', regex: /~([^~\n]+)~/ }
];

const styles = (theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    width: '100%'
  },
  conversations: {
    width: 320,
    minWidth: 320,
    flexShrink: 0,
    borderRight: '1px solid #ddd',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      width: 64,
      minWidth: 64
    }
  },
  conversationsHeader: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  conversationsHeaderTitulo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  conversationsList: {
    flexGrow: 1,
    overflowY: 'auto',
    border: 'none'
  },
  conversationItem: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5)
  },
  chatContainer: {
    flexGrow: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f5f5f5',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  chatContainerConversasExpandidas: {
    [theme.breakpoints.down('xs')]: {
      opacity: 0.55
    }
  },
  chatHeader: {
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderBottom: '1px solid #ddd'
  },
  messagesArea: {
    flexGrow: 1,
    padding: theme.spacing(2),
    overflowY: 'auto',
    position: 'relative'
  },
  inputArea: {
    display: 'flex',
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderTop: '1px solid #ddd'
  },
  messageReceived: {
    display: 'flex',
    justifyContent: 'flex-start',
    minWidth: 0,
    width: '100%',
    marginBottom: theme.spacing(0.5)
  },
  messageSent: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(0.5)
  },
  messageBubble: {
    maxWidth: '70%',
    minWidth: 0,
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 8,
    backgroundColor: '#fff'
  },
  messageBubbleSent: {
    maxWidth: '70%',
    width: 'fit-content',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 8,
    backgroundColor: '#dcf8c6'
  },
  messageText: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    fontSize: 14
  },
  messageDate: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  messageDateText: {
    backgroundColor: '#e5e5e5',
    padding: '4px 12px',
    borderRadius: 12,
    fontSize: 12,
    color: '#555'
  },
  messageTime: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 8,
    whiteSpace: 'nowrap',
    verticalAlign: 'bottom',
    fontSize: 11,
    color: '#777',
    float: 'right',
    height: 18,
    position: 'relative',
    top: 8
  },
  conversationContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  conversationText: {
    flexGrow: 1,
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  unreadBadge: {
    minWidth: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: '#25D366',
    color: '#fff',
    fontSize: 11,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 6px',
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      top: -5,
      right: -7,
      marginLeft: 0,
      minWidth: 14,
      height: 14,
      padding: '0 3px',
      borderRadius: 7,
      fontSize: 8
    }
  },
  conversationInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginLeft: theme.spacing(1)
  },
  conversationTime: {
    fontSize: 11,
    color: '#888',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  chatHeaderContent: {
    display: 'flex',
    alignItems: 'center'
  },
  chatHeaderName: { fontWeight: 500 },
  chatHeaderPhone: {
    fontSize: 13,
    color: '#777',
    marginLeft: theme.spacing(1)
  },
  messageStatus: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 4,
    fontSize: 12,
    lineHeight: 1
  },
  messageStatusLida: { color: '#34b7f1' },
  messageStatusErro: { color: '#d32f2f' },
  messageStatusLista: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 4,
    fontSize: 12,
    lineHeight: 1
  },
  imagemContainer: {
    position: 'relative',
    width: 250,
    maxWidth: '100%',
    aspectRatio: '1 / 1',
    overflow: 'hidden',
    borderRadius: 6,
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    boxSizing: 'border-box'
  },
  imagemContainerHover: {
    '&:hover $imagemMenuArea': {
      opacity: 1
    }
  },
  imagemMenuArea: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 130,
    height: 40,
    background:
      'linear-gradient(195deg, ' +
      'rgba(0,0,0,0.30) 0%, ' +
      'rgba(0,0,0,0.15) 10%, ' +
      'rgba(0,0,0,0) 50%, ' +
      'rgba(0,0,0,0) 100%)',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    padding: 4,
    boxSizing: 'border-box',
    pointerEvents: 'auto',
    opacity: 0,
    transition: 'opacity 0.2s ease'
  },
  imagemMenuBotao: {
    color: '#fff',
    width: 36,
    height: 36,
    padding: 0,
    pointerEvents: 'auto'
  },
  botaoConversas: {
    display: 'none',
    padding: 4,
    marginRight: -4,
    [theme.breakpoints.down('sm')]: {
      display: 'flex'
    }
  },
  botaoConversasRecolhido: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: 40,
      padding: 0,
      margin: 0,
      borderRadius: 0
    }
  },
  iniciaisContato: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 36,
      height: 36,
      borderRadius: '50%',
      fontSize: 13,
      fontWeight: 'bold'
    }
  },
  conversasExpandidas: {
    [theme.breakpoints.down('sm')]: {
      width: 320,
      minWidth: 320,
      '& $unreadBadge': {
        position: 'static',
        marginLeft: theme.spacing(1),
        minWidth: 20,
        height: 20,
        padding: '0 6px',
        borderRadius: 10,
        fontSize: 11
      },
      '& $conversationTime': {
        display: 'block'
      }
    },
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      zIndex: 101,
      left: 0,
      top: 0,
      bottom: 0,
      width: 320,
      minWidth: 320,
      boxShadow: '4px 0 12px rgba(0, 0, 0, 0.20)'
    }
  },
  conversationTextExpandida: {
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  conversationsDivider: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  conversationsDividerExpandido: {
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  conversationsHeaderExpandido: {
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  overlayConversas: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.15)',
      zIndex: 100,
      pointerEvents: 'auto'
    }
  },
  inputJanelaFechada: {
    '&::placeholder': {
      color: '#3b3b3b',
      opacity: 1
    }
  },
  novaMensagemIndicador: {
    position: 'absolute',
    bottom: 15,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
    padding: '7px 14px',
    borderRadius: 18,
    backgroundColor: '#fff',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
    fontSize: 13,
    cursor: 'pointer'
  }
});

const PROPS_TEXTO_PRIMARIO = {
  noWrap: true,
  style: { fontSize: 15 }
};

const PROPS_TEXTO_SECUNDARIO = {
  noWrap: true
};

const PROPS_PAPEL_MENU = {
  style: {
    borderRadius: 5,
    minWidth: 100,
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    marginTop: 0
  }
};

const ESTILO_MONOESPACO = {
  fontFamily: 'monospace',
  backgroundColor: '#f0f0f0',
  padding: '1px 4px',
  borderRadius: 3
};

const ESTILO_RESPOSTA = {
  borderLeft: '4px solid #25D366',
  backgroundColor: '#f5f5f5',
  padding: '6px 8px',
  marginBottom: 6,
  borderRadius: 4,
  cursor: 'pointer'
};

const ESTILO_RESPOSTA_NOME = {
  fontWeight: 600,
  color: '#128C7E'
};

const ESTILO_RESPOSTA_TEXTO = {
  color: '#555'
};

const ESTILO_BOTOES = {
  marginTop: 8,
  borderTop: '1px solid #e0e0e0'
};

const ESTILO_BOTAO_BASE = {
  padding: '7px 12px',
  textAlign: 'center',
  cursor: 'default'
};

const ESTILO_BOTAO = {
  ...ESTILO_BOTAO_BASE,
  borderTop: '1px solid #e0e0e0'
};

const ESTILO_BOTAO_PRIMEIRO = {
  ...ESTILO_BOTAO_BASE,
  borderTop: 'none'
};

const ESTILO_TEXTO_BOTAO = {
  color: '#008069',
  fontWeight: 500
};

const ESTILO_CLEAR = {
  clear: 'both'
};

const ESTILO_ALINHA_DIREITA = {
  textAlign: 'right'
};

const ESTILO_IMAGEM_CLICAVEL = {
  cursor: 'pointer'
};

const ESTILO_IMAGEM_NAO_CLICAVEL = {
  cursor: 'default'
};

const ESTILO_LOADING_IMAGEM = {
  color: '#aaa'
};

const ESTILO_IMAGEM_BASE = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};

const ESTILO_IMAGEM_VISIVEL = {
  ...ESTILO_IMAGEM_BASE,
  display: 'block'
};

const ESTILO_IMAGEM_OCULTA = {
  ...ESTILO_IMAGEM_BASE,
  display: 'none'
};

const ESTILO_BOTAO_MENU_IMAGEM = {
  position: 'absolute',
  top: -2,
  right: 0,
  width: 28,
  height: 28,
  padding: 0,
  color: '#fff',
  backgroundColor: 'transparent',
  boxShadow: 'none',
  pointerEvents: 'auto'
};

const ESTILO_SETA_FINAL = {
  position: 'absolute',
  right: 30,
  zIndex: 20,
  pointerEvents: 'none'
};

const ESTILO_RELATIVO = {
  position: 'relative'
};

const ESTILO_BOTAO_SETA = {
  backgroundColor: 'rgba(255, 255, 255, 0.90)',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
  pointerEvents: 'auto'
};

const ESTILO_BADGE_SETA = {
  position: 'absolute',
  top: -5,
  right: -5
};

const ESTILO_INPUT_AREA_LIBERADA = {
  pointerEvents: 'auto',
  opacity: 1
};

const ESTILO_INPUT_AREA_BLOQUEADA = {
  pointerEvents: 'none',
  opacity: 0.6
};

const ESTILO_LARGURA_TOTAL = {
  width: '100%'
};

const ESTILO_PREVIEWS = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  marginBottom: 8
};

const ESTILO_PREVIEW = {
  position: 'relative',
  display: 'inline-block',
  padding: 4,
  borderRadius: 10,
  backgroundColor: '#f0f0f0'
};

const ESTILO_PREVIEW_IMAGEM = {
  width: 100,
  height: 100,
  objectFit: 'cover',
  borderRadius: 8,
  display: 'block'
};

const ESTILO_REMOVER_PREVIEW = {
  position: 'absolute',
  top: -8,
  right: -8,
  width: 24,
  height: 24,
  padding: 0,
  backgroundColor: '#555',
  color: '#fff',
  border: '2px solid #fff',
  boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
};

const ESTILO_ICONE_REMOVER = {
  fontSize: 18,
  lineHeight: 1,
  fontWeight: 'bold'
};

const ESTILO_LINHA_INPUT = {
  display: 'flex',
  alignItems: 'center'
};

const ESTILO_ESCONDIDO = {
  display: 'none'
};

const ESTILO_BOTAO_IMAGEM = {
  marginRight: 8,
  width: 38,
  height: 38
};

const ESTILO_BOTAO_ENVIAR = {
  marginLeft: 8,
  width: 38,
  height: 38,
  color: '#fff',
  alignSelf: 'center',
  marginTop: 0
};

const ESTILO_ITEM_MENU = {
  minHeight: 30,
  height: 30,
  padding: '4px 10px',
  fontSize: 13
};

const ESTILO_ICONE_MENU = {
  fontSize: 17,
  marginRight: 7,
  color: '#555'
};

const ESTILO_ICONE_IMAGEM_LISTA = {
  fontSize: 18,
  marginRight: 4,
  verticalAlign: 'middle'
};

const ESTILO_IMAGEM_AMPLIADA = {
  maxWidth: '90vw',
  maxHeight: '90vh',
  objectFit: 'contain',
  display: 'block'
};

/* Retorna a classe base com a classe extra quando a condição for verdadeira */
const getClassName = (base, extra, condicao) => (
  condicao ? `${base} ${extra}` : base
);

/* Libera da memória as URLs de objetos (blob) criadas no navegador */
const liberarUrls = (urls) => {
  urls.forEach(url => URL.revokeObjectURL(url));
};

/* Retorna o Phone Number ID do WhatsApp configurado (por PDV ou geral) */
const getPhoneNumberId = () => {
  const especificaEnvioPorPDV = getConfigField('especificaenvioporpdv', 'cfg_crm');

  if (especificaEnvioPorPDV === ASIM) {
    const codPDV = sessionStorage.getItem('codPDV');
    const configsPDV = getConfigField('configpdvwhatsappcloudapi', 'cfg_crm');
    const configPDV = configsPDV?.find(item => String(item.codpdv) === String(codPDV));

    return configPDV ? configPDV.phonenumberid : '';
  }

  return getConfigField('phonenumberidwhatsappcloudapi', 'cfg_crm');
};

/* Verifica se a janela de 24h da conversa ainda está aberta */
const isJanelaAberta = (chat) => Boolean(
  chat &&
  chat.datahorafimjanela &&
  new Date(chat.datahorafimjanela) > new Date()
);

/* Converte o valor em Date (retorna null se for inválido) */
const parseData = (dataHora) => {
  if (!dataHora) {
    return null;
  }

  const data = new Date(dataHora);

  return isNaN(data.getTime()) ? null : data;
};

/* Verifica se as duas datas são do mesmo dia */
const mesmaData = (data1, data2) => (
  data1.getFullYear() === data2.getFullYear() &&
  data1.getMonth() === data2.getMonth() &&
  data1.getDate() === data2.getDate()
);

/* Formata a hora da mensagem (HH:mm) */
const formatarHora = (dataHora) => {
  const data = parseData(dataHora);

  if (!data) {
    return '';
  }

  return data.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

/* Formata a data do divisor de mensagens (Hoje, Ontem ou dd/mm/aaaa) */
const formatarDataMensagem = (dataHora) => {
  const data = parseData(dataHora);

  if (!data) {
    return '';
  }

  const hoje = new Date();
  const ontem = new Date();

  ontem.setDate(hoje.getDate() - 1);

  if (mesmaData(data, hoje)) {
    return 'Hoje';
  }

  if (mesmaData(data, ontem)) {
    return 'Ontem';
  }

  return data.toLocaleDateString('pt-BR');
};

/* Formata a data da lista de conversas (hora, Ontem ou dd/mm/aaaa) */
const formatarDataLista = (dataHora) => {
  const data = parseData(dataHora);

  if (!data) {
    return '';
  }

  const hoje = new Date();
  const ontem = new Date();

  ontem.setDate(hoje.getDate() - 1);

  // mensagem de hoje
  if (mesmaData(data, hoje)) {
    return formatarHora(dataHora);
  }

  // mensagem de ontem
  if (mesmaData(data, ontem)) {
    return 'Ontem';
  }

  // mensagem anterior
  return data.toLocaleDateString('pt-BR');
};

/* Verifica se deve mostrar o divisor de data antes da mensagem */
const deveMostrarData = (mensagens, indice) => {
  const mensagemAnterior = mensagens[indice - 1];

  if (indice === 0 || !mensagemAnterior) {
    return true;
  }

  return !mesmaData(
    new Date(mensagens[indice].datahoramsg),
    new Date(mensagemAnterior.datahoramsg)
  );
};

/* Formata a data para o padrão esperado pela API (aaaa-mm-dd hh:mm:ss.mmm) */
const formatarDataParaAPI = (data) => {
  const d = new Date(data);
  const ano = d.getFullYear();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  const hora = String(d.getHours()).padStart(2, '0');
  const minuto = String(d.getMinutes()).padStart(2, '0');
  const segundo = String(d.getSeconds()).padStart(2, '0');
  const milissegundo = String(d.getMilliseconds()).padStart(3, '0');

  return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}.${milissegundo}`;
};

/* Retorna as iniciais do contato (primeira e última palavra do nome) */
const obterIniciaisContato = (nome) => {
  if (!nome) {
    return '?';
  }

  const partes = nome.trim().split(/\s+/);

  if (partes.length === 1) {
    return partes[0].charAt(0).toUpperCase();
  }

  return (
    partes[0].charAt(0) +
    partes[partes.length - 1].charAt(0)
  ).toUpperCase();
};

/* Retorna a lista de botões da mensagem (vazia se o JSON for inválido) */
const parseBotoes = (botoes) => {
  try {
    const lista = JSON.parse(botoes);

    return Array.isArray(lista) ? lista : [];
  } catch (error) {
    console.error('Erro ao ler os botões da mensagem:', error);

    return [];
  }
};

/* Retorna a lista de chats com o chat informado na primeira posição */
const moverChatParaTopo = (chats, chatAtualizado) => [
  chatAtualizado,
  ...chats.filter(chat => Number(chat.id) !== Number(chatAtualizado.id))
];

/* Retorna o ícone e a classe extra do status da mensagem */
const getConfigStatus = (status) => {
  switch (status) {
    case STATUS_MSG_CHAT_ENVIANDO:
      return {
        Icone: AccessTime,
        fontSize: 13
      };
    case STATUS_MSG_CHAT_ENVIADA:
      return {
        Icone: Check,
        fontSize: 15
      };
    case STATUS_MSG_CHAT_RECEBIDA:
      return {
        Icone: DoneAll,
        fontSize: 15
      };
    case STATUS_MSG_CHAT_LIDA:
      return {
        Icone: DoneAll,
        fontSize: 15,
        classeExtra: 'messageStatusLida'
      };
    case STATUS_MSG_CHAT_ERRO:
      return {
        Icone: ErrorOutline,
        fontSize: 15,
        classeExtra: 'messageStatusErro'
      };
    default:
      return null;
  }
};

/* Aplica a formatação do WhatsApp (`mono`, *negrito*, _itálico_ e ~tachado~) */
const formatarMarcadores = (texto, nivel = 0) => {
  if (!texto || nivel > NIVEL_MAXIMO_FORMATACAO) {
    return texto;
  }

  const partes = [];
  let restante = texto;
  let chave = 0;

  while (restante.length > 0) {
    const matches = MARCADORES_WHATSAPP.map(({ tipo, regex }) => ({
      tipo,
      match: restante.match(regex)
    })).filter(item => item.match);

    // não encontrou nenhum marcador: adiciona o restante como texto normal
    if (matches.length === 0) {
      partes.push(restante);

      break;
    }

    // pega o marcador que aparece primeiro no texto
    matches.sort((a, b) => a.match.index - b.match.index);

    const primeiro = matches[0];
    const conteudo = primeiro.match[1];

    // texto antes do marcador
    if (primeiro.match.index > 0) {
      partes.push(restante.substring(0, primeiro.match.index));
    }

    // aplica o estilo correspondente
    switch (primeiro.tipo) {
      case 'negrito':
        partes.push(
          <strong key={chave++}>
            {formatarMarcadores(conteudo, nivel + 1)}
          </strong>
        );

        break;
      case 'italico':
        partes.push(
          <em key={chave++}>
            {formatarMarcadores(conteudo, nivel + 1)}
          </em>
        );

        break;
      case 'tachado':
        partes.push(
          <del key={chave++}>
            {formatarMarcadores(conteudo, nivel + 1)}
          </del>
        );

        break;
      case 'monoespaco':
        partes.push(
          <code
            key={chave++}
            style={ESTILO_MONOESPACO}
          >
            {conteudo}
          </code>
        );

        break;
      default:
        break;
    };

    // continua processando o que vem depois
    restante = restante.substring(primeiro.match.index + primeiro.match[0].length);
  }

  return partes;
};

/* Formata o texto da mensagem preservando as quebras de linha */
const formatarTextoWhatsApp = (texto) => {
  if (!texto) {
    return '';
  }

  const linhas = texto.split('\n');

  return linhas.map((linha, index) => (
    <React.Fragment key={index}>
      {formatarMarcadores(linha)}

      {index < linhas.length - 1 && <br />}
    </React.Fragment>
  ));
};

/* Formata o texto da lista de conversas (sem quebras de linha, para o noWrap funcionar) */
const formatarTextoWhatsAppLista = (texto) => {
  if (!texto) {
    return '';
  }

  return formatarMarcadores(texto.replace(/\r?\n/g, ' '));
};

class WhatsAppChat extends Component {
  _isMounted = false;
  safeSetState = safeSetState;

  messagesAreaRef = React.createRef();
  inputImagemRef = React.createRef();
  inputMensagemRef = React.createRef();
  inputAreaRef = React.createRef();

  timerPesquisa = null;
  timerJanela24h = null;
  websocket = null;
  inputAreaResizeObserver = null;

  midiasCache = {};

  state = {
    chats: [],
    carregandoChats: false,
    carregandoMaisChats: false,
    temMaisChats: true,
    ultimoChatCarregado: null,
    chatSelecionado: null,
    mensagens: [],
    carregandoMensagens: false,
    carregandoMaisMensagens: false,
    temMaisMensagens: true,
    textoMensagem: '',
    enviandoMensagem: false,
    textoPesquisa: '',
    imagemSelecionada: null,
    imagensCarregadas: {},
    arquivoImagem: null,
    previewImagem: null,
    arquivosImagem: [],
    previewsImagem: [],
    menuImagemAnchor: null,
    menuImagem: null,
    menuImagemAbrirDireita: true,
    conversasExpandidas: false,
    rascunhosChats: {},
    novaMensagemPendente: false,
    mostrarSetaFinal: false,
    alturaInputArea: 0
  };

  /* Carrega os dados iniciais da tela */
  componentDidMount() {
    this._isMounted = true;

    this.loadChats();
    this.conectarWebSocket();
    this.observarAlturaInputArea();
  };

  /* Limpa timers, conexão e mídias ao sair da tela */
  componentWillUnmount() {
    this._isMounted = false;

    const { previewsImagem, rascunhosChats } = this.state;

    if (this.inputAreaResizeObserver) {
      this.inputAreaResizeObserver.disconnect();
    }

    clearTimeout(this.timerPesquisa);
    clearTimeout(this.timerJanela24h);

    this.timerJanela24h = null;

    if (this.websocket) {
      this.websocket.close();
      this.websocket = null;
    }

    // libera da memória as mídias, prévias e rascunhos
    liberarUrls(Object.values(this.midiasCache));
    liberarUrls(previewsImagem);

    Object.values(rascunhosChats).forEach(rascunho => {
      liberarUrls(rascunho.previewsImagem || []);
    });

    this.midiasCache = {};
  };

  /* Observa a altura da área de digitação (posiciona a seta de ir para o final) */
  observarAlturaInputArea = () => {
    if (!this.inputAreaRef.current) {
      return;
    }

    this.inputAreaResizeObserver = new ResizeObserver(() => {
      const area = this.inputAreaRef.current;

      if (area) {
        this.safeSetState({ alturaInputArea: area.getBoundingClientRect().height });
      }
    });

    this.inputAreaResizeObserver.observe(this.inputAreaRef.current);
  };

  /* Carrega as conversas */
  loadChats = async () => {
    try {
      this.safeSetState({
        carregandoChats: true,
        temMaisChats: true
      });

      const phoneNumberId = getPhoneNumberId();

      if (!phoneNumberId) {
        console.warn('Phone Number ID do WhatsApp não configurado!');

        return;
      }

      const response = await api.get(`/whatsapp/meta/chat/${phoneNumberId}`, {
        params: { pesquisa: this.state.textoPesquisa.trim() || undefined }
      });

      if (response.data.success) {
        const { chats } = response.data;
        const ultimoChat = chats[chats.length - 1];

        this.safeSetState({
          chats,
          temMaisChats: chats.length === QTD_REGISTROS_PAGINA,
          ultimoChatCarregado: ultimoChat ? {
            data: ultimoChat.datahoraultimamsg,
            id: ultimoChat.id
          } : null
        });
      }
    } catch (error) {
      console.error('Erro ao carregar conversas WhatsApp:', error);
    } finally {
      this.safeSetState({ carregandoChats: false });
    }
  };

  /* Carrega mais conversas ao chegar no final da lista */
  carregarChatsAnteriores = async () => {
    const {
      carregandoMaisChats,
      temMaisChats,
      ultimoChatCarregado
    } = this.state;

    if (carregandoMaisChats || !temMaisChats || !ultimoChatCarregado) {
      return;
    }

    try {
      this.safeSetState({ carregandoMaisChats: true });

      const phoneNumberId = getPhoneNumberId();

      if (!phoneNumberId) {
        console.warn('Phone Number ID do WhatsApp não configurado!');

        return;
      }

      const response = await api.get(`/whatsapp/meta/chat/${phoneNumberId}`, {
        params: {
          antesDeData: formatarDataParaAPI(ultimoChatCarregado.data),
          antesDeId: ultimoChatCarregado.id
        }
      });

      if (response.data.success) {
        const chatsAnteriores = response.data.chats;

        if (chatsAnteriores.length < QTD_REGISTROS_PAGINA) {
          this.safeSetState({ temMaisChats: false });
        }

        if (!chatsAnteriores.length) {
          return;
        }

        const ultimoChat = chatsAnteriores[chatsAnteriores.length - 1];

        this.safeSetState(prevState => ({
          chats: [
            ...prevState.chats,
            ...chatsAnteriores
          ],
          ultimoChatCarregado: {
            data: ultimoChat.datahoraultimamsg,
            id: ultimoChat.id
          }
        }));
      }
    } catch (error) {
      console.error('Erro ao carregar conversas anteriores:', error);
    } finally {
      this.safeSetState({ carregandoMaisChats: false });
    }
  };

  /* Seleciona a conversa, salvando o rascunho da atual e restaurando o da selecionada */
  selecionarChat = async (chat) => {
    const {
      arquivosImagem,
      chatSelecionado,
      previewsImagem,
      rascunhosChats,
      textoMensagem
    } = this.state;

    const rascunhosAtualizados = { ...rascunhosChats };

    // salva o rascunho da conversa atual
    if (chatSelecionado) {
      rascunhosAtualizados[chatSelecionado.id] = {
        textoMensagem,
        arquivosImagem,
        previewsImagem
      };
    }

    // recupera o rascunho da conversa selecionada
    const rascunho = rascunhosAtualizados[chat.id];

    this.safeSetState({
      chatSelecionado: {
        ...chat,
        qtdemsgnaolidas: 0
      },
      mensagens: [],
      carregandoMensagens: true,
      temMaisMensagens: true,
      textoMensagem: rascunho?.textoMensagem || '',
      arquivosImagem: rascunho?.arquivosImagem || [],
      previewsImagem: rascunho?.previewsImagem || [],
      rascunhosChats: rascunhosAtualizados
    });

    try {
      const response = await api.get(`/whatsapp/meta/chat/mensagens/${chat.id}`);

      // outra conversa foi selecionada enquanto carregava
      if (this.state.chatSelecionado?.id !== chat.id) {
        return;
      }

      if (!response.data.success) {
        this.safeSetState({ carregandoMensagens: false });

        return;
      }

      const mensagens = [...response.data.mensagens].reverse();

      if (chat.qtdemsgnaolidas > 0) {
        await this.marcarComoLido(chat.id);
      }

      this.safeSetState(
        prevState => ({
          mensagens,
          carregandoMensagens: false,
          chats: prevState.chats.map(item => (
            item.id === chat.id ? {
              ...item,
              qtdemsgnaolidas: 0
            } : item
          )),
          chatSelecionado: {
            ...chat,
            qtdemsgnaolidas: 0
          }
        }), () => {
          this.scrollToBottom();
          this.carregarMidiasMensagens();
          this.configurarTimerJanela24h();
        }
      );
    } catch (error) {
      console.error('Erro ao carregar mensagens do chat:', error);

      this.safeSetState({ carregandoMensagens: false });
    }
  };

  /* Marca a conversa como lida no servidor (retorna true se conseguiu) */
  marcarComoLido = async (idChat) => {
    try {
      await api.put(`/whatsapp/meta/chat/lido/${idChat}`);

      return true;
    } catch (error) {
      console.error('Erro ao marcar conversa como lida:', error);

      return false;
    }
  };

  /* Marca a conversa como lida e zera o contador de não lidas no estado */
  marcarComoLidoNoEstado = async (idChat) => {
    const marcou = await this.marcarComoLido(idChat);

    if (!marcou) {
      return;
    }

    this.safeSetState(prevState => {
      const { chatSelecionado } = prevState;

      return {
        chats: prevState.chats.map(chat => (
          Number(chat.id) === Number(idChat) ? {
            ...chat,
            qtdemsgnaolidas: 0
          } : chat
        )),
        chatSelecionado: chatSelecionado && Number(chatSelecionado.id) === Number(idChat) ? {
          ...chatSelecionado,
          qtdemsgnaolidas: 0
        } : chatSelecionado
      };
    });
  };

  /* Envia a mensagem (texto e/ou imagens) para a conversa selecionada */
  enviarMensagem = async () => {
    const {
      arquivosImagem,
      chatSelecionado,
      previewsImagem,
      textoMensagem
    } = this.state;

    if (!chatSelecionado) {
      return;
    }

    // pode enviar somente texto, imagem, imagem + texto ou várias imagens
    if (!arquivosImagem.length && (!textoMensagem || !textoMensagem.trim())) {
      return;
    }

    try {
      this.safeSetState({
        textoMensagem: '',
        arquivosImagem: [],
        previewsImagem: [],
        arquivoImagem: null,
        previewImagem: null,
        enviandoMensagem: false
      });

      const codempresa = sessionStorage.getItem('codEmpresa') || '';
      const codpdv = sessionStorage.getItem('codPDV') || '';

      if (arquivosImagem.length) {
        await this.enviarImagens({
          arquivos: arquivosImagem,
          texto: textoMensagem,
          idchat: chatSelecionado.id,
          codempresa,
          codpdv
        });

        return;
      }

      const response = await api.post('/whatsapp/meta/enviamensagem', {
        codempresa,
        codpdv,
        idchat: chatSelecionado.id,
        texto: textoMensagem
      });

      if (!response.data.success) {
        this.marcarMensagemComErro(response.data.idMensagem, response.data.error);
      }
    } catch (error) {
      console.error('Erro ao enviar mensagem WhatsApp:', error);
    } finally {
      // as prévias já foram limpas da tela
      liberarUrls(previewsImagem);

      if (this.inputMensagemRef.current) {
        this.inputMensagemRef.current.focus();
      }
    }
  };

  /* Envia as imagens uma a uma (o texto vai somente na primeira) */
  enviarImagens = async ({ arquivos, texto, idchat, codempresa, codpdv }) => {
    for (let i = 0; i < arquivos.length; i++) {
      const formData = new FormData();

      formData.append('codempresa', codempresa);
      formData.append('codpdv', codpdv);
      formData.append('idchat', idchat);
      formData.append('texto', i === 0 ? texto || '' : '');
      formData.append('arquivoImagem', arquivos[i]);

      // o envio é sequencial para manter a ordem das imagens
      const response = await api.post('/whatsapp/meta/enviaimagem', formData);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao enviar imagem!');
      }
    }
  };

  /* Marca a mensagem como erro no estado */
  marcarMensagemComErro = (idMensagem, erro) => {
    this.safeSetState(prevState => ({
      mensagens: prevState.mensagens.map(mensagem => (
        Number(mensagem.id) === Number(idMensagem) ? {
          ...mensagem,
          status: STATUS_MSG_CHAT_ERRO,
          coderro: null,
          erro
        } : mensagem
      ))
    }));
  };

  /* Rola a área de mensagens até o final */
  scrollToBottom = () => {
    if (!this.messagesAreaRef.current) {
      return;
    }

    requestAnimationFrame(() => {
      const area = this.messagesAreaRef.current;

      if (area) {
        area.scrollTop = area.scrollHeight;
      }
    });
  };

  /* Verifica se a área de mensagens está rolada até o final */
  estaNoFinalMensagens = () => {
    const area = this.messagesAreaRef.current;

    if (!area) {
      return true;
    }

    const distanciaDoFinal = area.scrollHeight - area.scrollTop - area.clientHeight;

    return distanciaDoFinal <= DISTANCIA_FINAL_SCROLL;
  };

  /* Rola até a mensagem informada (carrega mensagens anteriores se necessário) */
  scrollParaMensagem = async (idMensagem) => {
    const buscarMensagem = () => this.state.mensagens.find(
      mensagem => Number(mensagem.id) === Number(idMensagem)
    );

    let mensagemEncontrada = buscarMensagem();

    while (!mensagemEncontrada && this.state.temMaisMensagens) {
      const quantidadeAntes = this.state.mensagens.length;

      await this.carregarMensagensAnteriores();

      if (this.state.mensagens.length === quantidadeAntes) {
        break;
      }

      mensagemEncontrada = buscarMensagem();
    }

    if (!mensagemEncontrada) {
      return;
    }

    const elemento = document.getElementById(`mensagem-chat-${idMensagem}`);
    const container = this.messagesAreaRef.current;

    if (!elemento || !container) {
      return;
    }

    const posicaoElemento =
      elemento.getBoundingClientRect().top -
      container.getBoundingClientRect().top +
      container.scrollTop;

    // o scroll não passa do limite da área (mensagens próximas do final)
    const posicaoMaxima = container.scrollHeight - container.clientHeight;
    const destino = Math.max(0, Math.min(posicaoElemento, posicaoMaxima));

    // escurece a mensagem
    const filtroOriginal = elemento.style.filter;

    elemento.style.filter = 'brightness(0.97)';

    // faz o scroll
    container.scrollTo({
      top: destino,
      behavior: 'smooth'
    });

    // aguarda o scroll chegar na mensagem (ou o tempo máximo)
    const limite = Date.now() + TEMPO_MAXIMO_SCROLL;

    const verificarScroll = () => {
      const distancia = Math.abs(container.scrollTop - destino);

      if (distancia <= 1 || Date.now() > limite) {
        // aguarda 0,2 segundo após chegar
        setTimeout(() => {
          elemento.style.filter = filtroOriginal;
        }, 200);

        return;
      }

      requestAnimationFrame(verificarScroll);
    };

    requestAnimationFrame(verificarScroll);
  };

  /* Trata o scroll da área de mensagens */
  handleScrollMensagens = (event) => {
    const { chatSelecionado, mostrarSetaFinal } = this.state;

    const estaNoFinal = this.estaNoFinalMensagens();

    if (event.target.scrollTop === 0) {
      this.carregarMensagensAnteriores();
    }

    // atualiza o estado somente quando a seta muda de visibilidade
    if (mostrarSetaFinal === estaNoFinal) {
      this.safeSetState({ mostrarSetaFinal: !estaNoFinal });
    }

    // voltou para o final da conversa: marca como lida
    if (estaNoFinal && mostrarSetaFinal && chatSelecionado) {
      this.marcarComoLidoNoEstado(chatSelecionado.id);
    }
  };

  /* Carrega mais mensagens ao chegar no topo da conversa */
  carregarMensagensAnteriores = async () => {
    const {
      carregandoMaisMensagens,
      chatSelecionado,
      mensagens,
      temMaisMensagens
    } = this.state;

    if (
      !chatSelecionado ||
      carregandoMaisMensagens ||
      !temMaisMensagens ||
      !mensagens.length
    ) {
      return false;
    }

    const idMensagemMaisAntiga = mensagens[0].id;

    try {
      this.safeSetState({ carregandoMaisMensagens: true });

      const response = await api.get(
        `/whatsapp/meta/chat/mensagens/${chatSelecionado.id}?antesDe=${idMensagemMaisAntiga}`
      );

      if (!response.data.success) {
        return false;
      }

      const mensagensAnteriores = [...response.data.mensagens].reverse();

      if (mensagensAnteriores.length < QTD_REGISTROS_PAGINA) {
        this.safeSetState({ temMaisMensagens: false });
      }

      if (!mensagensAnteriores.length) {
        return false;
      }

      const elemento = this.messagesAreaRef.current;
      const alturaAnterior = elemento.scrollHeight;

      await new Promise(resolve => {
        this.safeSetState(
          prevState => ({
            mensagens: [
              ...mensagensAnteriores,
              ...prevState.mensagens
            ]
          }),
          resolve
        );
      });

      // mantém a posição da rolagem na mesma mensagem
      elemento.scrollTop = elemento.scrollHeight - alturaAnterior;

      this.carregarMidiasMensagens();

      return true;
    } catch (error) {
      console.error('Erro ao carregar mensagens anteriores:', error);

      return false;
    } finally {
      this.safeSetState({ carregandoMaisMensagens: false });
    }
  };

  /* Carrega a mídia (blob) da mensagem, usando o cache quando existir */
  carregarMidia = async (mensagem) => {
    if (this.midiasCache[mensagem.id]) {
      return this.midiasCache[mensagem.id];
    }

    try {
      const codempresa = getConfigField('codempresa', 'cfg_crm');

      const response = await api.get(`/whatsapp/meta/chat/midia/${mensagem.id}`, {
        params: { codempresa },
        responseType: 'blob'
      });

      const url = URL.createObjectURL(response.data);

      // guarda no cache
      this.midiasCache[mensagem.id] = url;

      return url;
    } catch (error) {
      console.error('Erro ao carregar mídia da mensagem:', mensagem.id, error);

      return null;
    }
  };

  /* Carrega a mídia da mensagem e atualiza a URL dela no estado */
  carregarUrlMidia = async (mensagem) => {
    const url = await this.carregarMidia(mensagem);

    if (!url) {
      return;
    }

    this.safeSetState(prevState => ({
      mensagens: prevState.mensagens.map(item => (Number(item.id) === Number(mensagem.id) ? {
        ...item,
        urlmidia: url
      } : item))
    }));
  };

  /* Carrega as imagens das mensagens (da mais nova para a mais antiga) */
  carregarMidiasMensagens = async () => {
    const mensagensImagem = [...this.state.mensagens].reverse().filter(
      mensagem => mensagem.tipo === TIPO_MSG_CHAT_IMAGEM
    );

    await Promise.all(
      mensagensImagem.map(mensagem => this.carregarUrlMidia(mensagem))
    );
  };

  /* Marca a imagem como carregada (exibe no lugar do loading) */
  imagemCarregada = (id) => {
    this.setState(prevState => ({
      imagensCarregadas: {
        ...prevState.imagensCarregadas,
        [id]: true
      }
    }));
  };

  /* Abre a imagem ampliada */
  abrirImagem = (urlImagem) => {
    if (!urlImagem) {
      return;
    }

    this.setState({ imagemSelecionada: urlImagem });
  };

  /* Fecha a imagem ampliada */
  fecharImagem = () => {
    this.setState({ imagemSelecionada: null });
  };

  /* Seleciona as imagens a serem enviadas */
  selecionarImagem = (event) => {
    const arquivos = Array.from(event.target.files || []);

    if (!arquivos.length) {
      return;
    }

    const imagensValidas = arquivos.filter(arquivo => arquivo.type.startsWith('image/'));

    if (imagensValidas.length !== arquivos.length) {
      alert('Selecione somente arquivos de imagem!');
    }

    if (!imagensValidas.length) {
      event.target.value = '';

      return;
    }

    const previews = imagensValidas.map(arquivo => URL.createObjectURL(arquivo));
    const estavaNoFinal = this.estaNoFinalMensagens();

    this.setState(
      {
        arquivosImagem: imagensValidas,
        previewsImagem: previews
      },
      () => {
        if (estavaNoFinal) {
          this.scrollToBottom();
        }
      }
    );

    event.target.value = '';
  };

  /* Cancela a imagem selecionada (legado) */
  cancelarImagem = () => {
    if (this.state.previewImagem) {
      URL.revokeObjectURL(this.state.previewImagem);
    }

    this.setState({
      arquivoImagem: null,
      previewImagem: null
    });
  };

  /* Remove uma das imagens selecionadas */
  removerImagem = (index) => {
    const preview = this.state.previewsImagem[index];

    if (preview) {
      URL.revokeObjectURL(preview);
    }

    this.setState(prevState => ({
      arquivosImagem: prevState.arquivosImagem.filter((_, i) => i !== index),
      previewsImagem: prevState.previewsImagem.filter((_, i) => i !== index)
    }));
  };

  /* Abre o menu da imagem (para a direita ou para a esquerda, conforme o espaço) */
  abrirMenuImagem = (event, mensagem) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const espacoDireita = window.innerWidth - rect.left;

    this.setState({
      menuImagemAnchor: event.currentTarget,
      menuImagem: mensagem,
      menuImagemAbrirDireita: espacoDireita >= LARGURA_MENU_IMAGEM
    });
  };

  /* Fecha o menu da imagem */
  fecharMenuImagem = () => {
    this.setState({
      menuImagemAnchor: null,
      menuImagem: null
    });
  };

  /* Baixa a imagem da mensagem (janela "Salvar como") */
  baixarImagem = async (mensagem) => {
    if (!mensagem || !mensagem.urlmidia) {
      return;
    }

    try {
      const mimeType = mensagem.mimeType || 'image/jpeg';
      const extensao = EXTENSOES_IMAGEM[mimeType] || '.jpg';

      let nomeArquivo = mensagem.nomearquivo || `imagem_${mensagem.id}${extensao}`;

      // se o nome existente não possuir extensão, adiciona a do MIME
      if (mensagem.nomearquivo && !/\.[^/.]+$/.test(mensagem.nomearquivo)) {
        nomeArquivo += extensao;
      }

      // abre a janela "Salvar como"
      const handle = await window.showSaveFilePicker({
        suggestedName: nomeArquivo,
        types: [
          {
            description: 'Imagem',
            accept: { [mimeType]: [extensao] }
          }
        ]
      });

      // baixa a imagem
      const response = await fetch(mensagem.urlmidia);

      if (!response.ok) {
        throw new Error(`Erro ao baixar imagem: ${response.status}`);
      }

      const blob = await response.blob();

      // grava o arquivo
      const writable = await handle.createWritable();

      await writable.write(blob);
      await writable.close();
    } catch (error) {
      // usuário cancelou a janela de salvar
      if (error.name === 'AbortError') {
        return;
      }

      console.error('Erro ao baixar imagem:', error);
    }
  };

  /* Expande/recolhe a lista de conversas (telas pequenas) */
  alternarConversas = () => {
    this.setState(prevState => ({
      conversasExpandidas: !prevState.conversasExpandidas
    }));
  };

  /* Configura o timer que bloqueia o envio quando a janela de 24h fechar */
  configurarTimerJanela24h = () => {
    const { chatSelecionado } = this.state;

    // cancela o timer anterior
    if (this.timerJanela24h) {
      clearTimeout(this.timerJanela24h);

      this.timerJanela24h = null;
    }

    if (!chatSelecionado || !chatSelecionado.datahorafimjanela) {
      return;
    }

    const tempoRestante = new Date(
      chatSelecionado.datahorafimjanela
    ).getTime() - new Date().getTime();

    // janela já está fechada
    if (tempoRestante <= 0) {
      return;
    }

    // agenda exatamente para o horário de fechamento
    this.timerJanela24h = setTimeout(() => {
      this.timerJanela24h = null;

      if (this.inputMensagemRef.current) {
        this.inputMensagemRef.current.blur();
      }

      this.safeSetState({
        textoMensagem: '',
        arquivosImagem: [],
        previewsImagem: [],
        arquivoImagem: null,
        imagemSelecionada: null,
        previewImagem: null
      });
    }, tempoRestante);
  };

  /* Conecta no WebSocket para receber as mensagens em tempo real */
  conectarWebSocket = () => {
    const phoneNumberId = getPhoneNumberId();

    if (!phoneNumberId) {
      console.warn('Phone Number ID não configurado para o WebSocket!');

      return;
    }

    const ws = new WebSocket(WEBSOCKETURL);

    ws.onopen = () => {
      console.log('WebSocket conectado!');

      ws.send(JSON.stringify({
        evento: 'identificacao',
        phone_number_id: phoneNumberId
      }));
    };

    ws.onmessage = this.onMessageWebSocket;

    ws.onclose = () => {
      console.log('WebSocket desconectado');
    };

    ws.onerror = (error) => {
      console.error('Erro no WebSocket:', error);
    };

    this.websocket = ws;
  };

  /* Trata os eventos recebidos pelo WebSocket */
  onMessageWebSocket = (event) => {
    let mensagem;

    try {
      mensagem = JSON.parse(event.data);
    } catch (error) {
      console.error('Mensagem inválida recebida no WebSocket:', error);

      return;
    }

    if (
      mensagem.evento !== EVENTO_NOVA_MENSAGEM &&
      mensagem.evento !== EVENTO_MENSAGEM_ATUALIZADA
    ) {
      return;
    }

    const novaMensagem = mensagem.dados?.mensagem;

    if (!novaMensagem) {
      return;
    }

    if (mensagem.evento === EVENTO_MENSAGEM_ATUALIZADA) {
      this.atualizarMensagem(novaMensagem);

      return;
    }

    const mensagemJaExiste = this.state.mensagens.some(
      mensagemExistente => Number(mensagemExistente.id) === Number(novaMensagem.id)
    );

    if (mensagemJaExiste) {
      return;
    }

    const idChatSelecionado = this.state.chatSelecionado?.id;

    // mensagem pertence à conversa que está aberta
    if (idChatSelecionado && Number(novaMensagem.idchat) === Number(idChatSelecionado)) {
      this.receberMensagemChatAberto(novaMensagem);

      return;
    }

    this.receberMensagemOutroChat(novaMensagem);
  };

  /* Atualiza a mensagem existente (ex.: mudança de status) */
  atualizarMensagem = (novaMensagem) => {
    this.safeSetState(
      prevState => ({
        mensagens: prevState.mensagens.map(mensagemExistente => (
          Number(mensagemExistente.id) === Number(novaMensagem.id) ? {
            ...mensagemExistente,
            ...novaMensagem
          } : mensagemExistente
        )),
        chats: prevState.chats.map(chat => {
          const { ultimamensagem } = chat;

          if (
            Number(chat.id) !== Number(novaMensagem.idchat) ||
            !ultimamensagem ||
            Number(ultimamensagem.id) !== Number(novaMensagem.id)
          ) {
            return chat;
          }

          return {
            ...chat,
            ultimamensagem: {
              ...ultimamensagem,
              status: novaMensagem.status
            }
          };
        })
      }), () => {
        if (novaMensagem.tipo === TIPO_MSG_CHAT_IMAGEM && novaMensagem.midiaid) {
          this.carregarUrlMidia(novaMensagem);
        }
      }
    );
  };

  /* Adiciona a nova mensagem na conversa que está aberta */
  receberMensagemChatAberto = (novaMensagem) => {
    const estavaNoFinal = this.estaNoFinalMensagens();
    const recebida = novaMensagem.direcao === DIRECAO_MSG_CHAT_RECEBIDA;
    const dadosJanela = recebida ? { datahorafimjanela: novaMensagem.datahorafimjanela } : {};

    this.safeSetState(
      prevState => {
        const mensagens = [
          ...prevState.mensagens,
          novaMensagem
        ];

        const chat = prevState.chats.find(
          item => Number(item.id) === Number(novaMensagem.idchat)
        );

        if (!chat) {
          return { mensagens };
        }

        let qtdemsgnaolidas = Number(chat.qtdemsgnaolidas) || 0;

        if (recebida) {
          qtdemsgnaolidas = estavaNoFinal ? 0 : qtdemsgnaolidas + 1;
        }

        const chatAtualizado = {
          ...chat,
          ultimamensagem: novaMensagem,
          datahoraultimamsg: novaMensagem.datahoramsg,
          qtdemsgnaolidas,
          ...dadosJanela
        };

        const { chatSelecionado } = prevState;

        return {
          mensagens,
          chats: moverChatParaTopo(prevState.chats, chatAtualizado),
          chatSelecionado: chatSelecionado &&
            Number(chatSelecionado.id) === Number(novaMensagem.idchat) ? {
            ...chatSelecionado,
            qtdemsgnaolidas,
            ...dadosJanela
          } : chatSelecionado,
          novaMensagemPendente: !estavaNoFinal
        };
      }, async () => {
        this.configurarTimerJanela24h();

        if (estavaNoFinal) {
          this.scrollToBottom();

          await this.marcarComoLido(novaMensagem.idchat);
        }

        // se for imagem, carrega a mídia da Meta
        if (novaMensagem.tipo === TIPO_MSG_CHAT_IMAGEM) {
          await this.carregarUrlMidia(novaMensagem);
        }
      }
    );
  };

  /* Atualiza a lista com a nova mensagem de outra conversa (cria a conversa se não existir) */
  receberMensagemOutroChat = (novaMensagem) => {
    const recebida = novaMensagem.direcao === DIRECAO_MSG_CHAT_RECEBIDA;

    this.safeSetState(prevState => {
      const chat = prevState.chats.find(
        item => Number(item.id) === Number(novaMensagem.idchat)
      );

      if (!chat) {
        const novoChat = {
          id: novaMensagem.idchat,
          phone_number_id: novaMensagem.phone_number_id,
          wa_id: novaMensagem.wa_id,
          fone: novaMensagem.fone,
          nomecontato: novaMensagem.nomecontato,
          datahorainicio: novaMensagem.datahorainicio,
          datahoraultimamsg: novaMensagem.datahoramsg,
          datahoraultimamsgrecebida: novaMensagem.datahoramsg,
          datahorafimjanela: novaMensagem.datahorafimjanela,
          qtdemsgnaolidas: novaMensagem.qtdemsgnaolidas,
          ultimamensagem: novaMensagem
        };

        return {
          chats: [
            novoChat,
            ...prevState.chats
          ]
        };
      }

      const qtdemsgnaolidas = Number(chat.qtdemsgnaolidas) || 0;

      const chatAtualizado = {
        ...chat,
        ultimamensagem: novaMensagem,
        datahoraultimamsg: novaMensagem.datahoramsg,
        datahorafimjanela: novaMensagem.datahorafimjanela,
        qtdemsgnaolidas: recebida ? qtdemsgnaolidas + 1 : qtdemsgnaolidas
      };

      return {
        chats: moverChatParaTopo(prevState.chats, chatAtualizado)
      };
    });
  };

  /* Evento onChange da pesquisa (aguarda o usuário parar de digitar para consultar) */
  onChangePesquisa = (event) => {
    this.setState({ textoPesquisa: event.target.value });

    clearTimeout(this.timerPesquisa);

    this.timerPesquisa = setTimeout(() => {
      this.loadChats();
    }, INTERVALO_PESQUISA);
  };

  /* Evento onScroll da lista de conversas (carrega mais ao chegar perto do final) */
  onScrollConversas = (event) => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight
    } = event.currentTarget;

    if (scrollTop + clientHeight >= scrollHeight - DISTANCIA_FINAL_SCROLL) {
      this.carregarChatsAnteriores();
    }
  };

  /* Evento onChange do campo de mensagem */
  onChangeMensagem = (event) => {
    this.setState({ textoMensagem: event.target.value });
  };

  /* Evento onKeyDown do campo de mensagem (Enter envia, Shift+Enter quebra a linha) */
  onKeyDownMensagem = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();

      this.enviarMensagem();
    }
  };

  /* Recolhe a lista de conversas quando estiver expandida (telas pequenas) */
  recolherConversasMobile = () => {
    if (this.state.conversasExpandidas && window.innerWidth <= LARGURA_MAXIMA_MOBILE) {
      this.alternarConversas();
    }
  };

  /* Foca no campo de mensagem, com o cursor no final, se a janela de 24h estiver aberta */
  focarInputMensagem = (chat) => {
    const input = this.inputMensagemRef.current;

    if (input && isJanelaAberta(chat)) {
      const tamanho = input.value.length;

      input.focus();
      input.setSelectionRange(tamanho, tamanho);
    }
  };

  /* Clicar para abrir a conversa */
  onClickChat = (chat) => () => {
    this.selecionarChat(chat);
    this.recolherConversasMobile();

    setTimeout(() => {
      this.focarInputMensagem(chat);
    }, 0);
  };

  /* Clicar na mensagem respondida (rola até a mensagem original) */
  onClickMensagemRespondida = (idMensagem) => () => {
    this.scrollParaMensagem(idMensagem);
  };

  /* Clicar na imagem da mensagem (abre ampliada) */
  onClickImagem = (mensagem) => () => {
    if (mensagem.urlmidia) {
      this.abrirImagem(mensagem.urlmidia);
    }
  };

  /* Clicar no menu da imagem da mensagem */
  onClickMenuImagem = (mensagem) => (event) => {
    event.stopPropagation();

    this.abrirMenuImagem(event, mensagem);
  };

  /* Clicar para escolher as imagens */
  onClickSelecionarImagem = () => {
    this.inputImagemRef.current.click();
  };

  /* Clicar para baixar a imagem do menu */
  onClickBaixarImagem = () => {
    const mensagem = this.state.menuImagem;

    this.fecharMenuImagem();

    if (mensagem) {
      this.baixarImagem(mensagem);
    }
  };

  /* Renderiza o ícone de status da mensagem (lista = versão compacta da lista de conversas) */
  renderStatusMensagem = (mensagem, lista = false) => {
    const { classes } = this.props;

    if (mensagem.direcao !== DIRECAO_MSG_CHAT_ENVIADA) {
      return null;
    }

    const config = getConfigStatus(mensagem.status);

    if (!config) {
      return null;
    }

    const { Icone, fontSize, classeExtra } = config;
    const classeBase = lista ? classes.messageStatusLista : classes.messageStatus;

    const estiloIcone = lista ? {
      fontSize: fontSize - 1,
      verticalAlign: 'middle',
      position: 'relative',
      top: 3
    } : {
      fontSize,
      verticalAlign: 'middle'
    };

    return (
      <span
        className={getClassName(
          classeBase,
          classes[classeExtra],
          classeExtra
        )}
      >
        <Icone
          style={estiloIcone}
        />
      </span>
    );
  };

  /* Renderiza o horário e o status da mensagem */
  renderHorarioStatus = (mensagem) => (
    <span className={this.props.classes.messageTime}>
      {formatarHora(mensagem.datahoramsg)}

      {this.renderStatusMensagem(mensagem)}
    </span>
  );

  /* Renderiza a última mensagem da conversa na lista */
  renderUltimaMensagem = (mensagem) => {
    if (!mensagem) {
      return '';
    }

    const status = this.renderStatusMensagem(mensagem, true);

    // imagem
    if (mensagem.tipo === TIPO_MSG_CHAT_IMAGEM) {
      return (
        <span>
          {status}

          <Image
            style={ESTILO_ICONE_IMAGEM_LISTA}
          />

          {mensagem.texto ? formatarTextoWhatsAppLista(mensagem.texto) : 'Imagem'}
        </span>
      );
    }

    // documento
    if (mensagem.tipo === TIPO_MSG_CHAT_DOCUMENTO) {
      return (
        <span>
          {status}

          {mensagem.nomearquivo || 'Documento'}
        </span>
      );
    }

    // texto
    return (
      <span>
        {status}

        {formatarTextoWhatsAppLista(mensagem.texto || '')}
      </span>
    );
  };

  /* Renderiza a lista de conversas */
  renderConversas = () => {
    const { classes } = this.props;

    const {
      chats,
      conversasExpandidas,
      textoPesquisa
    } = this.state;

    return (
      <div
        className={getClassName(
          classes.conversations,
          classes.conversasExpandidas,
          conversasExpandidas
        )}
      >
        {!conversasExpandidas && (
          <IconButton
            className={classes.botaoConversasRecolhido}
            onClick={this.alternarConversas}
          >
            <KeyboardArrowRight />
          </IconButton>
        )}

        <div
          className={getClassName(
            classes.conversationsHeader,
            classes.conversationsHeaderExpandido,
            conversasExpandidas
          )}
        >
          <div className={classes.conversationsHeaderTitulo}>
            <Typography variant="h6">
              Conversas
            </Typography>

            {conversasExpandidas && (
              <IconButton
                className={classes.botaoConversas}
                onClick={this.alternarConversas}
              >
                <KeyboardArrowLeft />
              </IconButton>
            )}
          </div>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Pesquisar"
            margin="normal"
            value={textoPesquisa}
            onChange={this.onChangePesquisa}
          />
        </div>

        <Divider
          className={getClassName(
            classes.conversationsDivider,
            classes.conversationsDividerExpandido,
            conversasExpandidas
          )}
        />

        <List
          className={classes.conversationsList}
          onScroll={this.onScrollConversas}
        >
          {chats.map(this.renderConversa)}
        </List>
      </div>
    );
  };

  /* Renderiza uma conversa da lista */
  renderConversa = (chat) => {
    const { classes } = this.props;

    const {
      chatSelecionado,
      conversasExpandidas
    } = this.state;

    return (
      <ListItem
        button
        key={chat.id}
        className={classes.conversationItem}
        selected={Boolean(chatSelecionado && chatSelecionado.id === chat.id)}
        onClick={this.onClickChat(chat)}
      >
        <div className={classes.conversationContent}>
          {!conversasExpandidas && (
            <div className={classes.iniciaisContato}>
              {obterIniciaisContato(chat.nomecontato)}
            </div>
          )}

          <ListItemText
            className={getClassName(
              classes.conversationText,
              classes.conversationTextExpandida,
              conversasExpandidas
            )}
            primary={chat.nomecontato || chat.fone}
            secondary={this.renderUltimaMensagem(chat.ultimamensagem)}
            primaryTypographyProps={PROPS_TEXTO_PRIMARIO}
            secondaryTypographyProps={PROPS_TEXTO_SECUNDARIO}
          />

          <div className={classes.conversationInfo}>
            {chat.datahoraultimamsg && (
              <span className={classes.conversationTime}>
                {formatarDataLista(chat.datahoraultimamsg)}
              </span>
            )}

            {chat.qtdemsgnaolidas > 0 && (
              <div className={classes.unreadBadge}>
                {chat.qtdemsgnaolidas > 99 ? '99+' : chat.qtdemsgnaolidas}
              </div>
            )}
          </div>
        </div>
      </ListItem>
    );
  };

  /* Renderiza o cabeçalho do chat */
  renderCabecalhoChat = () => {
    const { classes } = this.props;
    const { chatSelecionado } = this.state;

    return (
      <div className={classes.chatHeader}>
        {chatSelecionado ? (
          <div className={classes.chatHeaderContent}>
            {chatSelecionado.nomecontato ? (
              <>
                <Typography
                  variant="h6"
                  className={classes.chatHeaderName}
                >
                  {chatSelecionado.nomecontato}
                </Typography>

                <Typography className={classes.chatHeaderPhone}>
                  • {chatSelecionado.fone}
                </Typography>
              </>
            ) : (
              <Typography variant="h6">
                {chatSelecionado.fone}
              </Typography>
            )}
          </div>
        ) : (
          <Typography variant="h6">
            Selecione uma conversa
          </Typography>
        )}
      </div>
    );
  };

  /* Renderiza o texto da mensagem com o horário e o status */
  renderTextoMensagem = (mensagem) => (
    <div>
      <Typography
        component="span"
        className={this.props.classes.messageText}
      >
        {formatarTextoWhatsApp(mensagem.texto)}
      </Typography>

      {this.renderHorarioStatus(mensagem)}

      <div
        style={ESTILO_CLEAR}
      />
    </div>
  );

  /* Renderiza a legenda da mídia (ou somente o horário e o status quando não houver texto) */
  renderLegendaMidia = (mensagem) => {
    if (mensagem.texto) {
      return this.renderTextoMensagem(mensagem);
    }

    return (
      <div style={ESTILO_ALINHA_DIREITA}>
        {this.renderHorarioStatus(mensagem)}
      </div>
    );
  };

  /* Renderiza a mensagem respondida (citação) */
  renderMensagemRespondida = (mensagem) => {
    const { mensagemrespondida } = mensagem;

    return (
      <div
        onClick={this.onClickMensagemRespondida(mensagemrespondida.id)}
        style={ESTILO_RESPOSTA}
      >
        <Typography
          variant="caption"
          style={ESTILO_RESPOSTA_NOME}
        >
          {mensagemrespondida.direcao === DIRECAO_MSG_CHAT_ENVIADA ? 'Você' : mensagem.nomecontato}
        </Typography>

        <Typography
          variant="body2"
          style={ESTILO_RESPOSTA_TEXTO}
        >
          {formatarTextoWhatsApp(mensagemrespondida.texto)}
        </Typography>
      </div>
    );
  };

  /* Renderiza os botões da mensagem */
  renderBotoes = (botoes) => (
    <div style={ESTILO_BOTOES}>
      {parseBotoes(botoes).map((botao, index) => (
        <div
          key={index}
          style={index > 0 ? ESTILO_BOTAO : ESTILO_BOTAO_PRIMEIRO}
        >
          <Typography
            variant="body2"
            style={ESTILO_TEXTO_BOTAO}
          >
            {botao}
          </Typography>
        </div>
      ))}
    </div>
  );

  /* Renderiza a mensagem de imagem */
  renderImagemMensagem = (mensagem) => {
    const { classes } = this.props;
    const carregada = Boolean(this.state.imagensCarregadas[mensagem.id]);

    return (
      <div>
        <div
          className={`${classes.imagemContainer} ${classes.imagemContainerHover}`}
          style={mensagem.urlmidia ? ESTILO_IMAGEM_CLICAVEL : ESTILO_IMAGEM_NAO_CLICAVEL}
          onClick={this.onClickImagem(mensagem)}
        >
          {(!mensagem.urlmidia || !carregada) && (
            <CircularProgress
              size={30}
              style={ESTILO_LOADING_IMAGEM}
            />
          )}

          {mensagem.urlmidia && (
            <>
              <img
                src={mensagem.urlmidia}
                alt=""
                onLoad={() => this.imagemCarregada(mensagem.id)}
                style={carregada ? ESTILO_IMAGEM_VISIVEL : ESTILO_IMAGEM_OCULTA}
              />

              <div className={classes.imagemMenuArea}>
                <IconButton
                  className={classes.imagemMenuBotao}
                  onClick={this.onClickMenuImagem(mensagem)}
                  style={ESTILO_BOTAO_MENU_IMAGEM}
                >
                  <KeyboardArrowDown />
                </IconButton>
              </div>
            </>
          )}
        </div>

        {this.renderLegendaMidia(mensagem)}
      </div>
    );
  };

  /* Renderiza a mensagem de documento */
  renderDocumentoMensagem = (mensagem) => (
    <div>
      <Typography>
        {mensagem.nomearquivo || 'Documento'}
      </Typography>

      {this.renderLegendaMidia(mensagem)}
    </div>
  );

  /* Renderiza uma mensagem (com o divisor de data, quando necessário) */
  renderMensagem = (mensagem, indice) => {
    const { classes } = this.props;

    const enviada = mensagem.direcao === DIRECAO_MSG_CHAT_ENVIADA;

    return (
      <React.Fragment key={mensagem.id}>
        {deveMostrarData(this.state.mensagens, indice) && (
          <div className={classes.messageDate}>
            <span className={classes.messageDateText}>
              {formatarDataMensagem(mensagem.datahoramsg)}
            </span>
          </div>
        )}

        <div
          id={`mensagem-chat-${mensagem.id}`}
          className={enviada ? classes.messageSent : classes.messageReceived}
        >
          <div className={enviada ? classes.messageBubbleSent : classes.messageBubble}>
            {mensagem.mensagemrespondida && this.renderMensagemRespondida(mensagem)}

            {mensagem.tipo === TIPO_MSG_CHAT_TEXTO && this.renderTextoMensagem(mensagem)}

            {mensagem.botoes && this.renderBotoes(mensagem.botoes)}

            {mensagem.tipo === TIPO_MSG_CHAT_IMAGEM && this.renderImagemMensagem(mensagem)}

            {mensagem.tipo === TIPO_MSG_CHAT_DOCUMENTO && this.renderDocumentoMensagem(mensagem)}
          </div>
        </div>
      </React.Fragment>
    );
  };

  /* Renderiza a área de mensagens */
  renderAreaMensagens = () => {
    const { classes } = this.props;

    const {
      carregandoMensagens,
      chatSelecionado,
      mensagens
    } = this.state;

    return (
      <div
        className={classes.messagesArea}
        ref={this.messagesAreaRef}
        onScroll={this.handleScrollMensagens}
      >
        {!chatSelecionado && (
          <Typography
            color="textSecondary"
            align="center"
          >
            Selecione uma conversa para visualizar as mensagens.
          </Typography>
        )}

        {chatSelecionado && carregandoMensagens && (
          <Typography
            color="textSecondary"
            align="center"
          >
            Carregando mensagens...
          </Typography>
        )}

        {chatSelecionado && !carregandoMensagens && mensagens.length === 0 && (
          <Typography
            color="textSecondary"
            align="center"
          >
            Nenhuma mensagem encontrada.
          </Typography>
        )}

        {chatSelecionado && !carregandoMensagens && mensagens.map(this.renderMensagem)}
      </div>
    );
  };

  /* Renderiza a seta para ir ao final da conversa (com o contador de não lidas) */
  renderSetaFinal = () => {
    const { classes } = this.props;

    const {
      alturaInputArea,
      chatSelecionado,
      mostrarSetaFinal
    } = this.state;

    if (!mostrarSetaFinal) {
      return null;
    }

    const qtdemsgnaolidas = chatSelecionado?.qtdemsgnaolidas;

    return (
      <div
        style={{
          ...ESTILO_SETA_FINAL,
          bottom: alturaInputArea + 10
        }}
      >
        <div style={ESTILO_RELATIVO}>
          <IconButton
            style={ESTILO_BOTAO_SETA}
            onClick={this.scrollToBottom}
          >
            <KeyboardArrowDown />
          </IconButton>

          {qtdemsgnaolidas > 0 && (
            <div
              className={classes.unreadBadge}
              style={ESTILO_BADGE_SETA}
            >
              {qtdemsgnaolidas > 99 ? '99+' : qtdemsgnaolidas}
            </div>
          )}
        </div>
      </div>
    );
  };

  /* Retorna o placeholder do campo de mensagem */
  getPlaceholderMensagem = (chatSelecionado, janelaAberta) => {
    if (!chatSelecionado) {
      return 'Selecione uma conversa...';
    }

    return janelaAberta ? 'Digite uma mensagem...' : 'Janela de envio fechada!';
  };

  /* Renderiza as prévias das imagens selecionadas */
  renderPreviewsImagem = () => {
    const { enviandoMensagem, previewsImagem } = this.state;

    if (!previewsImagem.length) {
      return null;
    }

    return (
      <div style={ESTILO_PREVIEWS}>
        {previewsImagem.map((preview, index) => (
          <div
            key={index}
            style={ESTILO_PREVIEW}
          >
            <img
              src={preview}
              alt={`Prévia ${index + 1}`}
              style={ESTILO_PREVIEW_IMAGEM}
            />

            <IconButton
              size="small"
              onClick={() => this.removerImagem(index)}
              disabled={enviandoMensagem}
              style={ESTILO_REMOVER_PREVIEW}
            >
              <span style={ESTILO_ICONE_REMOVER}>
                ×
              </span>
            </IconButton>
          </div>
        ))}
      </div>
    );
  };

  /* Renderiza a área de digitação */
  renderAreaInput = () => {
    const { classes } = this.props;

    const {
      arquivosImagem,
      chatSelecionado,
      enviandoMensagem,
      textoMensagem
    } = this.state;

    const janelaAberta = isJanelaAberta(chatSelecionado);
    const bloqueado = !chatSelecionado || !janelaAberta;

    const desabilitaEnvio = !chatSelecionado || enviandoMensagem || (
      !textoMensagem.trim() && !arquivosImagem.length
    );

    return (
      <div
        ref={this.inputAreaRef}
        className={classes.inputArea}
        style={bloqueado ? ESTILO_INPUT_AREA_BLOQUEADA : ESTILO_INPUT_AREA_LIBERADA}
      >
        <div style={ESTILO_LARGURA_TOTAL}>
          {this.renderPreviewsImagem()}

          <div style={ESTILO_LINHA_INPUT}>
            <input
              ref={this.inputImagemRef}
              type="file"
              accept="image/*"
              multiple
              style={ESTILO_ESCONDIDO}
              onChange={this.selecionarImagem}
            />

            <IconButton
              disabled={!chatSelecionado || enviandoMensagem}
              onClick={this.onClickSelecionarImagem}
              style={ESTILO_BOTAO_IMAGEM}
            >
              <Image />
            </IconButton>

            <TextField
              inputRef={this.inputMensagemRef}
              fullWidth
              variant="outlined"
              placeholder={this.getPlaceholderMensagem(chatSelecionado, janelaAberta)}
              size="small"
              multiline
              maxRows={5}
              disabled={!chatSelecionado || enviandoMensagem}
              InputProps={{
                classes: {
                  input: !janelaAberta && chatSelecionado ? classes.inputJanelaFechada : undefined
                }
              }}
              value={textoMensagem}
              onChange={this.onChangeMensagem}
              onKeyDown={this.onKeyDownMensagem}
            />

            <IconButton
              disabled={desabilitaEnvio}
              onClick={this.enviarMensagem}
              style={{
                ...ESTILO_BOTAO_ENVIAR,
                backgroundColor: desabilitaEnvio ? '#d5d5d5' : '#25D366'
              }}
            >
              <SendRounded />
            </IconButton>
          </div>
        </div>
      </div>
    );
  };

  /* Renderiza o menu da imagem (Baixar) */
  renderMenuImagem = () => {
    const {
      menuImagemAbrirDireita,
      menuImagemAnchor
    } = this.state;

    const horizontal = menuImagemAbrirDireita ? 'left' : 'right';

    return (
      <Menu
        anchorEl={menuImagemAnchor}
        open={Boolean(menuImagemAnchor)}
        onClose={this.fecharMenuImagem}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal
        }}
        PaperProps={PROPS_PAPEL_MENU}
      >
        <MenuItem
          onClick={this.onClickBaixarImagem}
          style={ESTILO_ITEM_MENU}
        >
          <GetApp
            style={ESTILO_ICONE_MENU}
          />
          Baixar
        </MenuItem>
      </Menu>
    );
  };

  /* Renderiza a imagem ampliada */
  renderImagemAmpliada = () => {
    const { imagemSelecionada } = this.state;

    return (
      <Dialog
        open={!!imagemSelecionada}
        onClose={this.fecharImagem}
        maxWidth={false}
      >
        <img
          src={imagemSelecionada}
          alt="Imagem"
          style={ESTILO_IMAGEM_AMPLIADA}
        />
      </Dialog>
    );
  };

  render() {
    const { classes } = this.props;
    const { conversasExpandidas } = this.state;

    return (
      <div className={classes.root}>
        {conversasExpandidas && (
          <div
            className={classes.overlayConversas}
          />
        )}

        {this.renderConversas()}

        <div
          className={getClassName(
            classes.chatContainer,
            classes.chatContainerConversasExpandidas,
            conversasExpandidas
          )}
          onClick={this.recolherConversasMobile}
        >
          {this.renderCabecalhoChat()}

          {this.renderAreaMensagens()}

          {this.renderSetaFinal()}

          {this.renderAreaInput()}
        </div>

        {this.renderMenuImagem()}

        {this.renderImagemAmpliada()}
      </div>
    );
  }
};

WhatsAppChat.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(WhatsAppChat);